module.exports = __webpack_public_path__ + "static/media/moodboard.4794be06.jpg";